/**
 * SASADM-0171 / SASADM-0172 — a `409 APP_HAS_TENANT_OVERRIDES` or
 * `409 DOCROOT_IN_USE_BY_TENANT_OVERRIDE` refusal: the server's message as-is (it names the
 * tenant ids; never parsed), else the catalog sentence, plus a link to each tenant's Whitelabel
 * tab (where its App builds panel reverts the override) when `error.details.tenantIds` lists any.
 *
 * SASADM-0176 (SASATH-0393 §1) — also an app delete's `409 APP_HAS_HOSTNAMES` (same
 * `error.details.tenantIds`) and `409 APP_IS_PRIMARY`; closable when `onClose` is given.
 */
import { Alert, Box, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { overrideTenantIds, type ApiError } from '@/api/errors';
import { useCopy } from '@/hooks/useCopy';

export function TenantOverridesNotice({ err, onClose }: { err: ApiError; onClose?: () => void }) {
  const { t } = useCopy();
  const ids = overrideTenantIds(err);
  return (
    <Alert severity="error" sx={{ mb: 2 }} onClose={onClose} closeText={t('common.close', 'Close')}>
      {err.details.message ?? t(`errors.codes.${err.code}`, err.code)}
      {ids.length > 0 && (
        <Box component="span" sx={{ display: 'block', mt: 0.5 }}>
          {t('appBuilds.affectedTenants', 'Tenants:')}{' '}
          {ids.map((id, i) => (
            <Box component="span" key={id}>
              {i > 0 && ', '}
              <Link component={RouterLink} to={`/tenants/${id}/whitelabel`}>
                #{id}
              </Link>
            </Box>
          ))}
        </Box>
      )}
    </Alert>
  );
}
